import React from 'react';
import styles from './Pane.module.scss';
import { useClassName } from '../hooks';

type PaneProps = {
  className?: string;
  fullWidth?: boolean;
};

const Pane: React.FC<React.PropsWithChildren<PaneProps>> = ({
  children,
  className,
  fullWidth = false
}) => {
  const cx = useClassName(styles['tk-pane'], className, {
    'full-width': fullWidth
  });

  return <div className={cx}>{children}</div>;
};

export default Pane;
